(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-collapsable-tab-v2"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCollapsableTabsV2() {
      const tabs = document.querySelectorAll('[data-collapsable-tab-v2]');

      tabs.forEach((tab) => {
        const handleToggle = () => {
          const isOpen = tab.classList.contains('is-open');

          // Only toggle if the tab is closed
          if (!isOpen) {
            // Find all tabs in the same container and close them
            const parentContainer = tab.closest('[data-tabs-container-v2]');
            if (parentContainer) {
              const allTabs = parentContainer.querySelectorAll('[data-collapsable-tab-v2]');
              allTabs.forEach((otherTab) => {
                if (otherTab !== tab) {
                  otherTab.classList.remove('is-open');
                  otherTab.classList.add('is-closed');
                  otherTab.setAttribute('role', 'button');
                  otherTab.setAttribute('tabindex', '0');
                  otherTab.setAttribute('aria-expanded', 'false');
                }
              });
            }

            // Open the clicked tab
            tab.classList.remove('is-closed');
            tab.classList.add('is-open');
            tab.removeAttribute('role');
            tab.removeAttribute('tabindex');
            tab.setAttribute('aria-expanded', 'true');
          }
        };

        // Add event listeners to all tabs
        tab.addEventListener('click', handleToggle);
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
          }
        });
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCollapsableTabsV2);
    } else {
      initCollapsableTabsV2();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-collapsable-tab"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCollapsableTabs() {
      const tabs = document.querySelectorAll('[data-collapsable-tab]');

      tabs.forEach((tab) => {
        const handleToggle = () => {
          const isOpen = tab.classList.contains('is-open');

          // Only toggle if the tab is closed
          if (!isOpen) {
            // Find all tabs in the same container and close them
            const parentContainer = tab.closest('[data-mobile-tabs], [data-tabs-container]');
            if (parentContainer) {
              const allTabs = parentContainer.querySelectorAll('[data-collapsable-tab]');
              allTabs.forEach((otherTab) => {
                if (otherTab !== tab) {
                  otherTab.classList.remove('is-open');
                  otherTab.classList.add('is-closed');
                  otherTab.setAttribute('role', 'button');
                  otherTab.setAttribute('tabindex', '0');
                  otherTab.setAttribute('aria-expanded', 'false');
                }
              });
            }

            // Open the clicked tab
            tab.classList.remove('is-closed');
            tab.classList.add('is-open');
            tab.removeAttribute('role');
            tab.removeAttribute('tabindex');
            tab.setAttribute('aria-expanded', 'true');
          }
        };

        // Add event listeners to all tabs
        tab.addEventListener('click', handleToggle);
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
          }
        });
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCollapsableTabs);
    } else {
      initCollapsableTabs();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
